import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

export const WafNode = (props) => {
    return <NodeWithMultipleHandles {...props} nodeType="waf" />;
};
